export const capitalizeFirstLetter = (str: string): string => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const toLocaleDateString = (date: string | Date, locale: string = 'fi-FI'): string => {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  return date.toLocaleDateString(locale) || '';
}